export const PERMISSIONS = {
    ADMIN_WEBSITES: 'admin.websites',
    ADMIN_API_KEYS: 'admin.apiKeys',
    ADMIN_STATISTICS: 'admin.statistics',
    ADMIN_API_LOGS: 'admin.apiLogs',
    ADMIN_UPDATES_PENDING: 'admin.updates.pending',
    ADMIN_UPDATES_COMPLETED: 'admin.updates.completed',
    ADMIN_UPDATES_FAILED: 'admin.updates.failed',
    ADMIN_USER_MANAGEMENT: 'admin.userManagement',
    ADMIN_SYSTEM_SETTINGS: 'admin.systemSettings',
    ADMIN_MAINTENANCE_BYPASS: 'admin.maintenanceBypass',
    ADMIN_SUPER_USER: 'admin.superUser',
    ADMIN_AUDIT_LOGS: 'admin.auditLogs',
}

export const DEFAULT_PERMISSIONS = [
    {
        key: PERMISSIONS.ADMIN_WEBSITES,
        name: 'Websites',
        description: 'Darf die verwalteten Websites öffnen.',
    },
    {
        key: PERMISSIONS.ADMIN_API_KEYS,
        name: 'API Keys',
        description: 'Darf API Keys verwalten.',
    },
    {
        key: PERMISSIONS.ADMIN_STATISTICS,
        name: 'Statistiken',
        description: 'Darf die Update-Statistiken öffnen.',
    },
    {
        key: PERMISSIONS.ADMIN_API_LOGS,
        name: 'API Logs',
        description: 'Darf die API Logs öffnen.',
    },
    {
        key: PERMISSIONS.ADMIN_UPDATES_PENDING,
        name: 'Ausstehende Updates',
        description: 'Darf ausstehende Updates öffnen.',
    },
    {
        key: PERMISSIONS.ADMIN_UPDATES_COMPLETED,
        name: 'Gelaufene Updates',
        description: 'Darf gelaufene Updates öffnen.',
    },
    {
        key: PERMISSIONS.ADMIN_UPDATES_FAILED,
        name: 'Fehlgeschlagene Updates',
        description: 'Darf fehlgeschlagene Updates öffnen.',
    },
    {
        key: PERMISSIONS.ADMIN_USER_MANAGEMENT,
        name: 'Userverwaltung',
        description: 'Darf Benutzer und Rechte verwalten.',
    },
    {
        key: PERMISSIONS.ADMIN_SYSTEM_SETTINGS,
        name: 'Systemeinstellungen',
        description: 'Darf Logo, Firmenname und Systemoptionen verwalten.',
    },
    {
        key: PERMISSIONS.ADMIN_MAINTENANCE_BYPASS,
        name: 'Wartungsmodus umgehen',
        description: 'Bleibt auch bei aktivem Wartungsmodus eingeloggt.',
    },
    {
        key: PERMISSIONS.ADMIN_SUPER_USER,
        name: 'Superuser',
        description: 'Darf Superuser verwalten und dieses Recht vergeben.',
    },
    {
        key: PERMISSIONS.ADMIN_AUDIT_LOGS,
        name: 'Audit Logs',
        description: 'Darf die Audit Logs öffnen.',
    },
]

export const DEFAULT_ADMIN_PERMISSION_KEYS = [
    PERMISSIONS.ADMIN_WEBSITES,
    PERMISSIONS.ADMIN_API_KEYS,
    PERMISSIONS.ADMIN_STATISTICS,
    PERMISSIONS.ADMIN_API_LOGS,
    PERMISSIONS.ADMIN_UPDATES_PENDING,
    PERMISSIONS.ADMIN_UPDATES_COMPLETED,
    PERMISSIONS.ADMIN_UPDATES_FAILED,
    PERMISSIONS.ADMIN_USER_MANAGEMENT,
    PERMISSIONS.ADMIN_SYSTEM_SETTINGS,
    PERMISSIONS.ADMIN_MAINTENANCE_BYPASS,
    PERMISSIONS.ADMIN_SUPER_USER,
    PERMISSIONS.ADMIN_AUDIT_LOGS,
]
